import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { Button, Splash } from '@autopass-web/mochi-component';
import { PageContainer } from '#/guest-aps/components/page-container';
import { PinIcon } from '#/guest-aps/components/pin-icon';
import { EntryMainImage } from '#/guest-aps/features/entry/entry-main-image';
import { useBulletinBoards } from '#/guest-aps/services/use-bulletin-boards';
import amplitude from '#/guest-aps/services/amplitude';
import { parseApsStyles } from '#/guest-aps/utils/parse-aps-styles';
import { useAmplitudeEntryPageView } from '#/guest-aps/hooks/use-amplitude-entry-page-view';
import { PATH, URL_PRIVACY, URL_TERMS } from '#/guest-aps/config';
import type { Parkinglot } from '@autopass-web/types';

interface EntryPageTemplateProps {
  isParkinglotFetched: boolean;
  parkinglot: Parkinglot | null;
}

export const EntryPageTemplate = ({
  isParkinglotFetched,
  parkinglot,
}: EntryPageTemplateProps) => {
  const navigate = useNavigate();
  const { bulletinBoards, getBulletinBoardsStatus } = useBulletinBoards(
    {
      codes: 'aps_partner_template',
      partnerId: parkinglot?.partner_id,
    },
    {
      enabled: !!parkinglot?.partner_id,
    },
  );

  const isInit = isParkinglotFetched && getBulletinBoardsStatus === 'success';

  // To record the user's entry page view
  useAmplitudeEntryPageView(isInit);

  const apsPartnerTemplate = bulletinBoards?.aps_partner_template?.[0];
  const { appBackgroundStyleObj, appTextStyleObj, appTextColor, entryImage } =
    parseApsStyles(apsPartnerTemplate);

  return (
    <>
      <Splash init={isInit} />
      <PageContainer style={{}}>
        <div className={styles.top} style={appBackgroundStyleObj}>
          <div className={styles.title} style={appTextStyleObj}>
            <div className={styles.parkinglot}>
              <PinIcon textColor={appTextColor} />
              {parkinglot?.name}
            </div>
            <h1>
              歡迎使用
              <br />
              停車線上繳費
            </h1>
          </div>
          <EntryMainImage imageUrl={entryImage} />
        </div>
        <div className={styles.bottom}>
          <div className={styles.agreement}>
            開始使用即同意
            <a
              href={URL_TERMS}
              rel="noopener noreferrer"
              onClick={amplitude.entryTermsOnClick}
            >
              服務條款
            </a>
            &nbsp;/&nbsp;
            <a
              href={URL_PRIVACY}
              rel="noopener noreferrer"
              onClick={amplitude.entryPrivacyOnClick}
            >
              隱私權政策
            </a>
          </div>
          <Button
            style={{
              ...appBackgroundStyleObj,
              ...appTextStyleObj,
              width: '80%',
              marginBottom: '6px',
            }}
            type="solid-round"
            size="full"
            onClick={() => {
              amplitude.entryButtonOnClick();
              navigate(PATH.SEARCH_PLATE_NUMBER);
            }}
          >
            開始使用
          </Button>
        </div>
      </PageContainer>
    </>
  );
};
